const answerMap = {
  1: 'A',
  2: 'B',
  3: 'C',
  4: 'D'
};

export default answerMap;
